import React from 'react';
import './activePoliciesSelect.css';
import { Select, MenuItem } from '@mui/material';
import { translations } from '../../lib/consts';
type GenericObject = { [key: string]: any };

export const ActivePoliciesSelect = (data: GenericObject) => {
    return (
        <Select name={data.name} onChange={data.onChange} label={data.label} value={data.value}>
            {data.items.map((policy: GenericObject) => {
                const validFrom = new Date(policy.validFrom);
                const dateFrom = `${validFrom.getDate()}/${validFrom.getMonth() + 1}/${validFrom.getFullYear()}`;
                const validTo = new Date(policy.validTo);
                const dateTo = `${validTo.getDate()}/${validTo.getMonth() + 1}/${validTo.getFullYear()}`;
                return (
                    <MenuItem key={policy.id} value={policy.id} style={{ whiteSpace: 'normal' }}>
                        <div>
                            <div>
                                <span style={{ fontWeight: 'bold' }}>{`${translations.POLICY_NUMBER}: `}</span>
                                {policy.policyNumber}
                            </div>
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.TIME_PERIOD}: `}</span>
                                {`${dateFrom} - ${dateTo}`}
                            </div>
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.VEHICLE_BRAND_AND_TYPE}: `}</span>
                                {`${policy.vehicleBrand} ${policy.vehicleType} ${policy.vehicleId}`}
                            </div>
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.CHASSIS_NUMBER}: `}</span>
                                {policy.chassisNumber}
                            </div>
                        </div>
                    </MenuItem>
                );
            })}
        </Select>
    );
};
